module.exports = __webpack_public_path__ + "static/media/ProfessionalBehavior.e2ca2d29.svg";